export { default } from "./GamesRedirect";
